<template>
  <b-form @submit.prevent="submit">
    <b-row>
      <b-col md="2">
        <b-form-group label="Estatus">
          <b-form-select v-model="form.status" :options="statusOptions" />
        </b-form-group>
      </b-col>
      <b-col md="2">
        <b-form-group label="Tipo de fecha">
          <b-form-select v-model="form.dateType" :options="dateTypeOptions" @change="changeDateType" />
        </b-form-group>
      </b-col>
      <b-col md="2">
        <b-form-group label="Desde">
          <b-form-input v-model="form.startDate" type="date" :disabled="!form.dateType" />
        </b-form-group>
      </b-col>
      <b-col md="2">
        <b-form-group label="Hasta">
          <b-form-input v-model="form.endDate" type="date" :disabled="!form.dateType" />
        </b-form-group>
      </b-col>
      <b-col md="2">
        <b-form-group label="Vivienda">
          <b-form-input v-model="form.numberHousing" type="text" inputmode="numeric" :state="housingState" placeholder="Número" />
          <b-form-invalid-feedback>Ingrese un número de vivienda válido</b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col md="2">
        <b-form-group label="Propietario">
          <b-form-input v-model="form.nameOwner" type="text" placeholder="Nombre" />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="8">
        <small v-if="rangeIncomplete" class="text-danger">Llegada y Salida requiere ambas fechas</small>
      </b-col>
      <b-col md="4" class="text-right">
        <b-button variant="warning" class="mr-1" :disabled="isLoading" @click="clear">Limpiar</b-button>
        <b-button variant="primary" type="submit" :disabled="isLoading || !isValid">Buscar</b-button>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import { xcalacocoBookingStatusOptions, xcalacocoBookingDateTypeOptions } from '@/data/xcalacocoBookings'

const MAX_INT = 2147483647

function initialForm() {
  return {
    status: '1',
    dateType: null,
    startDate: '',
    endDate: '',
    numberHousing: '',
    nameOwner: '',
  }
}

export default {
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    initialFilters: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    const form = { ...initialForm(), ...this.initialFilters }
    form.numberHousing = form.numberHousing ? String(form.numberHousing) : ''
    return {
      form,
      statusOptions: xcalacocoBookingStatusOptions,
      dateTypeOptions: xcalacocoBookingDateTypeOptions,
    }
  },
  computed: {
    housingState() {
      const value = this.form.numberHousing.trim()
      if (!value) return null
      return /^\d+$/.test(value) && Number(value) >= 1 && Number(value) <= MAX_INT ? null : false
    },
    rangeIncomplete() {
      return this.form.dateType === 'range' && !this.form.startDate !== !this.form.endDate
    },
    isValid() {
      return this.housingState !== false && !this.rangeIncomplete
    },
  },
  methods: {
    changeDateType(value) {
      if (!value) {
        this.form.startDate = ''
        this.form.endDate = ''
      }
    },
    buildParams() {
      const { form } = this
      const params = { status: form.status }
      const hasDates = form.startDate || form.endDate
      if (form.dateType && hasDates) {
        params.dateType = form.dateType
        params.startDate = form.startDate
        params.endDate = form.endDate
      }
      const numberHousing = form.numberHousing.trim()
      if (numberHousing) params.numberHousing = parseInt(numberHousing, 10)
      const nameOwner = form.nameOwner.trim()
      if (nameOwner) params.nameOwner = nameOwner
      return params
    },
    submit() {
      if (!this.isValid || this.isLoading) return
      this.$emit('search', this.buildParams())
    },
    clear() {
      this.form = initialForm()
      this.$emit('search', this.buildParams())
    },
  },
}
</script>
